import { Controller } from "@hotwired/stimulus"

export default class AdminBundlePackageController extends Controller {
  static targets = ["select", "packages", "packageContainer"]

  connect() {
    this.packagesGroup = JSON.parse(this.element.dataset.packagesGroup)
  }

  showPackageDropdown() {
    const dropdown = `
      <div class="package-item my-3 flex items-center gap-x-3" data-controller="admin--bundle-item">
        <select data-admin--bundle-package-target="select"
                class="w-full border-gray-300 rounded-md text-sm focus:border-gray-500 focus:ring-0"
                required>
          <option value="">เลือกแพ็กเกจ</option>
          ${this.packagesGroup.map(group => {
            return `
              <optgroup label="${group.product_name}">
                ${group.packages.map(pack => {
                  return `<option value="${pack.id}">${pack.name}</option>`
                }).join("")}
              </optgroup>
              `
          }).join("")}
        </select>
        <button type="button" title="เอาแพ็กเกจนี้ออก" class="shrink-0 px-2.5 py-1.5 text-sm text-gray-400 border border-gray-300 rounded-md hover:text-red-500 hover:border-red-300" data-action="admin--bundle-item#remove">✕</button>
      </div>
    `
    this.packageContainerTarget.insertAdjacentHTML("beforeend", dropdown)
  }

  submitForm(event) {
    const packagesId = this.selectTargets.map(item => item.value)
    this.packagesTarget.value = JSON.stringify(packagesId)

    const form = event.target
    form.submit()
  }
}
